const TableLoader = () => {
    return (
      <table>
        <tbody>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
          <tr>
            <td className="td-1">
              <span></span>
            </td>
            <td className="td-2">
              <span></span>
            </td>
            <td className="td-3">
              <span></span>
            </td>
            <td className="td-4">
              <span></span>
            </td>
            <td className="td-5">
              <span></span>
            </td>
            <td className="td-6">
              <span></span>
              <span></span>
            </td>
          </tr>
        </tbody>
      </table>
    );
};
export default TableLoader;
